module.exports = __webpack_public_path__ + "static/media/successful-upload.964f32af.svg";